import React, { Component } from 'react'
import * as Constants from './constants.js'
import $ from 'jquery'
import InstanciaImagen from './instancias/InstanciaImagen.js'
import InstanciaAdjunto from './instancias/InstanciaAdjunto.js';
import WarningIcon from '@material-ui/icons/Warning'
import Timezone from '../../commons/timezone/Timezone.js'

class AtributoDinamicoInstancia extends Component {
	constructor(props) {
    super(props);
    this.props = props;
  }

	componentDidMount() {
		$('.popover2').popover()
	}

	componentWillUnmount() {
		$('.popover2').popover('hide');
	}

	escapeHtml(value) {
		if (!value) return '';
		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	// VEC-3476: contenido del popover con el detalle de la última validación de
	// "Mínimo Vital" de este ítem (decisión, usuario, comentario, fecha).
	renderMinimoVitalPopoverContent(ultimaValidacion) {
		let intl = this.props.intl;
		let decisionLabel = ultimaValidacion.decision === Constants.ID_DECISION_INVALIDO
			? intl.formatMessage({ id: 'atributoDinamicoInstancia.minimo_vital.decision_invalido', defaultMessage: 'Rechazado' })
			: intl.formatMessage({ id: 'atributoDinamicoInstancia.minimo_vital.decision_valido', defaultMessage: 'Resuelto' });
		let usuario = ultimaValidacion.usuario_validador ? this.escapeHtml(ultimaValidacion.usuario_validador.nombre) : '';
		let fecha = ultimaValidacion.created_at ? Timezone.getDateForClient(ultimaValidacion.created_at, null, 'DD/MM/YYYY HH:mm') : '';
		let motivo = this.escapeHtml(ultimaValidacion.motivo);

		return '<div style="padding: 0.75rem">' +
			'<div><strong>' + decisionLabel + '</strong>' + (fecha ? (' - ' + fecha) : '') + '</div>' +
			(usuario ? ('<div>' + usuario + '</div>') : '') +
			(motivo ? ('<div>' + motivo + '</div>') : '') +
			'</div>';
	}

	render() {
			let tipoValor = this.props.atributo.tipoValor ? this.props.atributo.tipoValor : 0
			let InstanciaDinamica = Constants.INSTANCIAS_DICT[tipoValor].clase
			if (!InstanciaDinamica) return null
			let estadoRequiereInfo = this.props.atributo.estadosInformativos &&
															 this.props.atributo.estadosInformativos.find(estado => estado.id == this.props.atributo.estado)
			let instanciaConEstados = Constants.INSTANCIAS_DICT[tipoValor].conEstados
			let mostrarObservaciones = estadoRequiereInfo && instanciaConEstados && !this.props.previsualizacion
			let isEvidenciaObservacionObligatoria = this.props.atributo.evidencia_observacion_obligatoria > 0 ? true : false
			let isEvidenciaImagenObligatoria = this.props.atributo.evidencia_imagen_obligatoria > 0 ? true : false
			let isEvidenciaDocumentoObligatoria = this.props.atributo.evidencia_documento_obligatoria > 0 ? true : false
      return (
        <React.Fragment>
							<>
								<label className="col-md-3 label-control col-form-label">
									<span className={!this.props.atributo.description ? 'hidden' : ''}>
										<i
											className="cursor-pointer fa fa-info-circle popover2"
											data-toggle="popover" title="Instrucciones"
											onClick={event => event.preventDefault()}
											data-html={true}
											data-content={this.props.atributo.description}
										/>&nbsp;
									</span>

									{this.props.atributo.nombre} {this.props.atributo.required ? '*' : ''}:
								</label>
								<div className={instanciaConEstados ? "col-md-8 col-8 my-auto" : "col-md-9 col-12"}>
									<InstanciaDinamica
										ocultarInput={this.props.ocultarInput}
										disabled={this.props.disabled}
										previsualizacion={this.props.previsualizacion}
										handleChange={this.props.handleChange}
										atributo={this.props.atributo}
										movil={this.props.movil}
									/>
								</div>
								<div className={instanciaConEstados ? "col-md-1 col-4 my-auto" : "hidden"} style={{ position: 'relative' }}>
									<div className="text-center">
										{this.props.atributo.estado == Constants.ID_ESTADO_APROBACION_VALIDO ?
											<i className="fa fa-2x fa-check success"></i> : ''
										}
										{this.props.atributo.estado == Constants.ID_ESTADO_APROBACION_INVALIDO ?
											<i className="fa fa-2x fa-times-circle-o danger"></i> : ''
										}
									</div>
									{/* VEC-3476: si este ítem es de "Mínimo Vital" y ya tiene una validación
									registrada, se avisa con el mismo ícono de alerta que se usa en la grilla.
									Posicionado absoluto para no correr el ícono de estado (check/x) cuando
									aparece, así todos quedan alineados entre filas tengan o no minimo vital.
									Requiere intl (no todos los consumidores de este componente lo pasan —
									ej. FormularioAsociadoBloque — ahí directamente no se muestra). */}
									{!!this.props.intl && !!this.props.atributo.minimo_vital && !!this.props.atributo.ultima_validacion &&
										<span
											className="cursor-pointer popover2"
											style={{ color: '#FF9800', position: 'absolute', top: '50%', left: '100%', marginLeft: '4px', transform: 'translateY(-50%)', marginTop: '3px' }}
											data-toggle="popover" title={this.props.intl.formatMessage({ id: 'atributoDinamicoInstancia.minimo_vital.titulo_popover', defaultMessage: 'Histórico de Mínimo Vital' })}
											onClick={event => event.preventDefault()}
											data-html={true}
											data-content={this.renderMinimoVitalPopoverContent(this.props.atributo.ultima_validacion)}
										>
											<WarningIcon style={{ fontSize: '1.8em' }} />
										</span>
									}
								</div>

								{mostrarObservaciones &&
									<>
										<label className="col-md-3 label-control col-form-label">
											Observaciones { isEvidenciaObservacionObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<textarea
												disabled={this.props.disabled}
												className="form-control"
												value={this.props.atributo.observaciones}
												onChange={event => this.props.handleChange("observaciones", event.target.value)}
												rows="1"
											/>
										</div>
										<label className="col-md-3 label-control col-form-label">
											Imagen { isEvidenciaImagenObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<InstanciaImagen
												disabled={this.props.disabled}
												previsualizacion={this.props.previsualizacion}
												valueKey={'adjunto_id'}
												handleChange={(name, value) => this.props.handleChange(name, value)}
												atributo={this.props.atributo}
											/>
										</div>
										<label className="col-md-3 label-control col-form-label">
											Documento { isEvidenciaDocumentoObligatoria && <>* </> }:
										</label>
										<div className="col-md-9">
											<InstanciaAdjunto
												disabled={this.props.disabled}
												previsualizacion={this.props.previsualizacion}
												valueKey={'documento_id'}
												handleChange={(name, value) => this.props.handleChange(name, value)}
												atributo={this.props.atributo}
												accept=".pdf,.doc,.docx,.txt,.xls,.xlsx,.zip,.rar,.mp4,.mp3,.avi,.csv"
											/>
										</div>
									</>
								}
							</>
        </React.Fragment>
      )
  }
}

export default AtributoDinamicoInstancia;
